var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAttribution = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "globe")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0.-Menu-General-",
    transform: "translate(-34.000000, -526.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.-Visualization-Copy-2",
    transform: "translate(33.000000, 476.989154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universe-Selection-Copy",
    transform: "translate(0.000000, 45.989154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.998265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Editor-/-pie_chart",
    transform: "translate(0.000000, 1.199479)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 13.8974164 0 13.8974164 13.8974164 0 13.8974164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94870821,1.15811803 C3.75230243,1.15811803 1.15811803,3.75230243 1.15811803,6.94870821 C1.15811803,10.145114 3.75230243,12.7392984 6.94870821,12.7392984 C10.145114,12.7392984 12.7392984,10.145114 12.7392984,6.94870821 C12.7392984,3.75230243 10.145114,1.15811803 6.94870821,1.15811803 Z M11.5406462,6.36964919 L7.52776722,6.36964919 L7.52776722,2.3567702 C9.61817027,2.61734676 11.2800697,4.27924614 11.5406462,6.36964919 Z M2.31623607,6.94870821 C2.31623607,4.59193801 4.08815666,2.64050912 6.36964919,2.3567702 L6.36964919,11.5406462 C4.08815666,11.2569073 2.31623607,9.30547841 2.31623607,6.94870821 Z M7.52776722,11.5406462 L7.52776722,7.52776722 L11.5406462,7.52776722 C11.2800697,9.61817027 9.61817027,11.2800697 7.52776722,11.5406462 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAttribution, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/attribution.aebe5bdb.svg";
export { ForwardRef as ReactComponent };